module.exports = __webpack_public_path__ + "img/homePad_pack_logo.d856b285.svg";